import { render, staticRenderFns } from "./checkEditorRunPosture.vue?vue&type=template&id=50df86ba&scoped=true&"
import script from "./checkEditorRunPosture.vue?vue&type=script&lang=js&"
export * from "./checkEditorRunPosture.vue?vue&type=script&lang=js&"
import style0 from "./checkEditorRunPosture.vue?vue&type=style&index=0&id=50df86ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df86ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50df86ba')) {
      api.createRecord('50df86ba', component.options)
    } else {
      api.reload('50df86ba', component.options)
    }
    module.hot.accept("./checkEditorRunPosture.vue?vue&type=template&id=50df86ba&scoped=true&", function () {
      api.rerender('50df86ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkEditorRunPosture.vue"
export default component.exports